const route = {
  path: 'system-config',
  name: '系统配置',
  component: {
    render: e => e('router-view')
  },
  children: [
    {
      path: 'param-setting',
      name: '参数配置',
      component: () => import('../views/systemConfig/paramSetting.vue')
    },
    {
      path: 'role-manage',
      name: '角色管理',
      component: () => import('../views/systemConfig/roleManage.vue')
    },
    {
      path: 'menu-manage',
      name: '菜单管理',
      component: () => import('../views/systemConfig/menuManage.vue')
    },
    {
      path: 'operate-log',
      name: '操作日志',
      component: () => import('../views/systemConfig/operateLog.vue')
    }
  ]
}

export default route



// WEBPACK FOOTER //
// ./src/router/systemConfigRouter.js